import { UserInfo, ConversationRequest, Conversation, ChatMessage, CosmosDBHealth, CosmosDBStatus, CrmIncidentType, SupportType, SupportEntry, BCNProcessTest, BCNProcessModule, BCNProcess } from "./models";
import { chatHistorySampleData } from "../../../../Components/Chatbot/constants/chatHistory";
import { Item } from "../../../../Model/PartnerModels";
import { HttpHelper, HttpMethod } from "../../../../Core/Http/HttpHelper";
import { AxiosRequestHeaders, AxiosResponse } from "axios";

export const performApiRequest = (path: string, httpMethod: HttpMethod, body?: any, signal?: AbortSignal): Promise<any> => {
    const XApiKey = process.env.REACT_APP_API_KEY_CHATBOT;
    let instance = HttpHelper.buildAxiosInstance(9000000, XApiKey);
    const headers: AxiosRequestHeaders = {
        "Content-Type": "application/json",
        "Profile-Origin": encodeURIComponent(window.location.origin + window.location.pathname),
    };

    switch(httpMethod){
        case HttpMethod.GET:
            return instance.get(path, {signal: signal, headers: headers});
        case HttpMethod.POST:
            return instance.post(path, body, {signal: signal, headers: headers});
        case HttpMethod.PUT:
            return instance.put(path, body, {signal: signal, headers: headers});
        case HttpMethod.PATCH:
            return instance.patch(path, body, {signal: signal, headers: headers});
        case HttpMethod.DELETE:
            return instance.delete(path, {signal: signal, headers: headers});
    }
}

export async function conversationApi(options: ConversationRequest, abortSignal: AbortSignal): Promise<Response> {
    const response = await fetch(HttpHelper.buildBaseEndpoint() + "/api/eoschat/conversation", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-API-KEY": process.env.REACT_APP_API_KEY_CHATBOT!,
            "Profile-Origin": encodeURIComponent(window.location.origin + window.location.pathname),
        },
        body: JSON.stringify({
            messages: options.messages,
            languageCode: options.languageCode
        }),
        signal: abortSignal
    });

    return response;
}

export async function getUserInfo(): Promise<UserInfo[]> {
    const response = await fetch('/.auth/me');
    if (!response.ok) {
        console.log("No identity provider found. Access to chat will be blocked.")
        return [];
    }

    const payload = await response.json();
    return payload;
}

// export const fetchChatHistoryInit = async (): Promise<Conversation[] | null> => {
export const fetchChatHistoryInit = (): Conversation[] | null => {
    // Make initial API call here

    // return null;
    return chatHistorySampleData;
}

export const historyList = async (): Promise<Conversation[] | null> => {
    const response = await fetch("/history/list", {
        method: "GET",
    }).then(async (res) => {
        const payload = await res.json();
        if (!Array.isArray(payload)) {
            console.error("There was an issue fetching your data. 1");
            return null;
        }
        const conversations: Conversation[] = await Promise.all(payload.map(async (conv: any) => {
            let convMessages: ChatMessage[] = [];
            convMessages = await historyRead(conv.id)
            .then((res) => {
                return res
            })
            .catch((err) => {
                console.error("error fetching messages: ", err)
                return []
            })
            const conversation: Conversation = {
                id: conv.id,
                title: conv.title,
                languageCode: conv.languageCode,
                date: conv.createdAt,
                messages: convMessages
            };
            return conversation;
        }));
        return conversations;
    }).catch((err) => {
        console.error("There was an issue fetching your data. 2");
        return null
    })

    return response
}

export const historyRead = async (convId: string): Promise<ChatMessage[]> => {
    const response = await fetch("/history/read", {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId
        }),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then(async (res) => {
        if(!res){
            return []
        }
        const payload = await res.json();
        let messages: ChatMessage[] = [];
        if(payload?.messages){
            payload.messages.forEach((msg: any) => {
                const message: ChatMessage = {
                    id: msg.id,
                    role: msg.role,
                    date: msg.createdAt,
                    content: msg.content,
                    type: msg.type
                }
                messages.push(message)
            });
        }
        return messages;
    }).catch((err) => {
        console.error("There was an issue fetching your data. 3");
        return []
    })
    return response
}

export const historyGenerate = async (options: ConversationRequest, abortSignal: AbortSignal, convId?: string): Promise<Response> => {
    let body;
    if(convId){
        body = JSON.stringify({
            conversation_id: convId,
            messages: options.messages
        })
    }else{
        body = JSON.stringify({
            messages: options.messages
        })
    }
    const response = await fetch("/history/generate", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: body,
        signal: abortSignal
    }).then((res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue fetching your data. 4");
        return new Response;
    })
    return response
}

export const historyUpdate = async (messages: ChatMessage[], convId: string): Promise<Response> => {
    const instance = HttpHelper.buildAxiosInstance();

    return new Promise((resolve,reject)=> {
        instance.post(
            "/api/chat/history/update",
            JSON.stringify({
                conversation_id: convId,
                messages: messages
            }),
            {
                headers: {
                    "Content-Type": "application/json",
                    "Profile-Origin": encodeURIComponent(window.location.origin + window.location.pathname),
                }
            }
        ).then((res) => {
            return res;
        })
        .catch((err) => {
            console.error("There was an issue fetching your data. 4");
            let errRes: Response = {
                ...new Response,
                ok: false,
                status: 500,
            }
            return errRes;
        });
    })
}

export const historyDelete = async (convId: string) : Promise<Response> => {
    const response = await fetch("/history/delete", {
        method: "DELETE",
        body: JSON.stringify({
            conversation_id: convId,
        }),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then((res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue fetching your data. 5");
        let errRes: Response = {
            ...new Response,
            ok: false,
            status: 500,
        }
        return errRes;
    })
    return response;
}

export const historyDeleteAll = async () : Promise<Response> => {
    const response = await fetch("/history/delete_all", {
        method: "DELETE",
        body: JSON.stringify({}),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then((res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue fetching your data. 6");
        let errRes: Response = {
            ...new Response,
            ok: false,
            status: 500,
        }
        return errRes;
    })
    return response;
}

export const historyClear = async (convId: string) : Promise<Response> => {
    const response = await fetch("/history/clear", {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId,
        }),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then((res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue fetching your data. 7");
        let errRes: Response = {
            ...new Response,
            ok: false,
            status: 500,
        }
        return errRes;
    })
    return response;
}

export const historyRename = async (convId: string, title: string) : Promise<Response> => {
    const response = await fetch("/history/rename", {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId,
            title: title
        }),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then((res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue fetching your data. 8");
        let errRes: Response = {
            ...new Response,
            ok: false,
            status: 500,
        }
        return errRes;
    })
    return response;
}

export const historyEnsure = async (): Promise<CosmosDBHealth> => {
    const response = await fetch("/history/ensure", {
        method: "GET",
    })
    .then(async res => {
        let respJson = await res.json();
        let formattedResponse;
        if(respJson.message){
            formattedResponse = CosmosDBStatus.Working
        }else{
            if(res.status === 500){
                formattedResponse = CosmosDBStatus.NotWorking
            }else{
                formattedResponse = CosmosDBStatus.NotConfigured
            }
        }
        if(!res.ok){
            return {
                cosmosDB: false,
                status: formattedResponse
            }
        }else{
            return {
                cosmosDB: true,
                status: formattedResponse
            }
        }
    })
    .catch((err) => {
        console.error("There was an issue fetching your data. 9");
        return {
            cosmosDB: false,
            status: err
        }
    })
    return response;
}

export const getSupportTypes = async (): Promise<CrmIncidentType[]> => {
    const response = await performApiRequest("/api/EosChat/crm/incident/type", HttpMethod.GET)
    .then(async (resp) => {
        const data = resp.data;
        return data;
    })
    .catch((err) => {
        console.error("There was an issue fetching incident types.");
        return err;
    });
    
    return response;
}

export const getSupportEntry = (supportId: string): Promise<SupportEntry> => {
    return new Promise((resolve, reject) => {
        performApiRequest("/api/EosChat/support/entry/" + supportId, HttpMethod.GET)
        .then(async (resp) => {
            const data = resp.data;
            resolve(data);
        })
        .catch((err) => {
            console.error("There was an issue fetching support entry.");
            reject(err);
        });
    });
}


export function updateCurrentChat(payload: Conversation) : Conversation { 
    const messages: ChatMessage[] =  payload.messages.filter((message) => message.isLogged === undefined || message.isLogged === false);
    if((messages.length === 1) && (messages[0].subType === 'welcomeMessage'))
        return payload;

    historyUpdate(messages, payload.id);

    let updatedConversation: Conversation = payload;
    messages.forEach((message) => {
        updatedConversation.messages.find((msgToUpdate) => msgToUpdate.id === message.id)!.isLogged = true;
    });

    return updatedConversation;
}
